<template>
  <div class="box" :class="props.class">
    <div v-if="$slots.header || $slots.actions" class="box-header py-3">
      <div class="box-header__title ps-3 flex-grow-1">
        <slot name="header" />
      </div>
      <div class="box-header__actions px-3 gap-1 flex-wrap">
        <slot name="actions" />
      </div>
      <vertical-loader v-if="props.loading" />
    </div>
    <slot />
    <div v-if="$slots.footer" class="box-footer px-3 py-3 gap-1">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup>
import VerticalLoader from '@/components/UI/VerticalLoader.vue';

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  class: {
    type: String,
    default: '',
  },
});
</script>

<style lang="scss" scoped>
.box {
  border-radius: var(--hp-box-border-radius);
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  --hp-box-header-height: 54px;
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--bs-border-color);
  position: relative;
  flex-grow: 1;
  gap: 1rem;
  min-height: var(--hp-box-header-height);

  @include media-breakpoint-down(md) {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 8px;
  }
}
.box-header__title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: calc(100% - 80px);
  @include media-breakpoint-down(md) {
    max-width: calc(100% - 1rem);
  }
}

.box-header__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;

  @include media-breakpoint-down(md) {
    justify-content: flex-start;
  }
}
.box-footer {
  border-top: 1px solid var(--bs-border-color);
  overflow: hidden;
}
</style>
